export default __webpack_public_path__ + "static/media/Ario.f5da12b4.svg";